'use strict';
var classof = require('../internals/classof');

module.exports = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-big-int-array.js
// module id = 523
// module chunks = 0